import React from 'react';
import HeaderSection from './HeaderSection';
import HeroSection from './HeroSection';
import DetailsSection from './DetailsSection';

const MillionaireMakersSpecialReport: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#d9dce4] text-[#101010]">
      <HeaderSection />
      <HeroSection />
      <DetailsSection />
      <div className="w-full h-[40px] bg-[#1A2A44]" aria-hidden="true" />
    </div>
  );
};

export default MillionaireMakersSpecialReport;
